import { render, staticRenderFns } from "./Merchants.vue?vue&type=template&id=240e1956"
import script from "./Merchants.vue?vue&type=script&lang=js"
export * from "./Merchants.vue?vue&type=script&lang=js"
import style0 from "./Merchants.vue?vue&type=style&index=0&id=240e1956&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports